export const globalHeaderHeightNormal = 64;
export const globalHeaderHeightSmall = 56;
